"use client";

import { useState, useEffect } from "react";
import posthog from "posthog-js";

import { POSTHOG_DISTINCT_ID_FORM_FIELD } from "@/lib/posthog-constants";

export function PosthogDistinctIdField() {
	const [value, setValue] = useState("");

	useEffect(() => {
		try {
			const id = posthog.get_distinct_id();
			// eslint-disable-next-line react-hooks/set-state-in-effect
			if (id) setValue(id);
		} catch {
			// posthog not initialized
		}
	}, []);

	return <input type="hidden" name={POSTHOG_DISTINCT_ID_FORM_FIELD} value={value} readOnly />;
}
